import { trenigoLogoFullDark, trenigoLogoFullLight } from '@trenigo/brand';

/**
 * Logo Trenigo z @trenigo/brand pro předrenderovanou stránku. Na rozdíl od TrenigoLogo (varianta
 * podle useEffectiveTheme za běhu) jsou v HTML obě varianty a viditelnou vybírá CSS podle
 * data-theme, které nastaví theme-init.js před prvním vykreslením (bez JS podle
 * prefers-color-scheme), viz LandingPage.css. Logo se tak ani v tmavém motivu po hydrataci
 * nepřepíná a předrenderované HTML je pro všechny motivy stejné (bez hydration mismatch).
 * Skrytá varianta má display: none, takže ji čtečky obrazovky nečtou.
 */
export function LandingBrandLogo({ alt, className = '' }: { alt: string; className?: string }) {
  return (
    <>
      <img src={trenigoLogoFullLight} alt={alt} className={`${className} brand-logo-light`.trim()} />
      <img src={trenigoLogoFullDark} alt={alt} className={`${className} brand-logo-dark`.trim()} />
    </>
  );
}
